"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { Container } from "@/components/ui/container";
import { Rocket, LayoutDashboard, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/auth-context";

export function AppHeader() {
  const { user, logout } = useAuth();
  const router = useRouter();

  const handleLogout = () => {
    logout();
    router.push("/");
  };

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-md">
      <Container className="flex h-14 items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2.5 group">
          <div className="flex size-7 items-center justify-center rounded-md bg-linear-to-br from-brand-highlight to-brand-accent text-white shadow-sm shadow-brand-highlight/30">
            <Rocket className="size-3.5" />
          </div>
          <span className="text-sm font-semibold tracking-tight text-foreground">
            delta<span className="text-deck-blue">DAO</span>
          </span>
        </Link>

        {/* Nav */}
        <nav className="flex items-center gap-1">
          <Link
            href="/#how-it-works"
            className="hidden sm:inline-flex h-8 items-center justify-center rounded-lg px-3 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
          >
            How it works
          </Link>

          {user ? (
            <>
              <Link
                href="/deployments"
                className="inline-flex h-8 items-center justify-center gap-1.5 rounded-lg px-3 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
              >
                <LayoutDashboard className="size-3.5" />
                <span className="hidden sm:inline">My Deployments</span>
              </Link>
              <span className="hidden sm:inline text-xs text-muted-foreground px-1">{user.email}</span>
              <button
                onClick={handleLogout}
                className="inline-flex h-8 items-center justify-center gap-1.5 rounded-lg px-3 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
              >
                <LogOut className="size-3.5" />
                <span className="hidden sm:inline">Sign out</span>
              </button>
              <Link
                href="/deploy"
                className="inline-flex h-8 items-center justify-center gap-1.5 rounded-lg border-0 bg-linear-to-r from-brand-highlight to-brand-accent px-4 text-sm font-medium text-white shadow-md shadow-brand-highlight/20 transition-all hover:opacity-90"
              >
                Deploy now
              </Link>
            </>
          ) : (
            <>
              <Link
                href="/login"
                className="inline-flex h-8 items-center justify-center rounded-lg px-3 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
              >
                Sign in
              </Link>
              <Link
                href="/deploy"
                className="inline-flex h-8 items-center justify-center gap-1.5 rounded-lg border-0 bg-linear-to-r from-brand-highlight to-brand-accent px-4 text-sm font-medium text-white shadow-md shadow-brand-highlight/20 transition-all hover:opacity-90"
              >
                Deploy now
              </Link>
            </>
          )}
        </nav>
      </Container>
    </header>
  );
}
